import { addressSchema } from '../../../schemas/address.schema';
import { z } from 'zod/v4';

export const companyInfoSchema = z.object({
  contactName: z.string().min(1).nullable(),
  title: z.string().nullable().optional(),
  email: z.string().min(1).nullable(),
  phone: z.string().min(1).nullable(),
  address: addressSchema.nullable().optional(),
});

export type CompanyInfo = z.infer<typeof companyInfoSchema>;
